<template>
  <div class="d-flex mt-3">
    <div class="text-start pl-2 py-1 flex-grow-1">
      <slot></slot>
    </div>
  </div>
  <LayerElement v-for="(layer, i) in props.layers" :key="i" :layer-id="layer.id" @update="activeVerification" />
</template>

<script lang="ts" setup>
// Components import
import type { Layer } from '@tsyl/karonte/lib/types/layers'

import LayerElement from './LayerElement.vue'

const props = defineProps({
  layers: {
    type: Array<Layer>,
    required: true
  },
  group: {
    type: String,
    required: true
  }
})

const exclusiveLayerGroups: string[] = ['riskLayers', 'effis', 'burnedAreas:viirs']

const activeVerification = (layer: Layer) => {
  if (exclusiveLayerGroups.includes(props.group)) {
    props.layers.forEach((e) => {
      if (layer.id !== e.id) e.setActive(false)
    })
  }
}
</script>

<style lang="scss" scoped></style>
